export const PICTURE_POPUP_TYPES = {
  COVER_IMAGE: 'coverImage',
  PICTURE: 'picture',
};
